"use client";
import React, { useCallback, useEffect, useState } from 'react';
import Link from "next/link";
import style from "./login.module.css"
import { useRouter } from 'next/navigation';
import deviceInfo from '../utils/deviceInfo';
import tohash from '../utils/tohash';
import { useAuthStore } from '../store/authstore';
import { syncfav } from '../utils/syncfav';
import { useFavoriteStore, useLoaderStore, useToastStore } from '../store/localapi';
import { fetchWithLoader } from '../utils/api';
import validator from '../utils/validator';
import Revoke from '../component/rovoke/Revoke';
import GoogleLogin from './GoogleLogin';
import FacebookLogin from './FacebookLogin';
import buildUserObj from '../utils/buildUserObj';


interface Devices {
  device_id: string;
  device_name: string;
  last_login: string;
}

export default function Login() {
  const router = useRouter()
  const [useremail, setUseremail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [terms, setTerms] = useState<boolean>(false)
  const [minage, setMinage] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isRevoke, setIsRevoke] = useState<boolean | null>(null);
  const [devices, setDevices] = useState<Devices[]>([]);

  const login = useAuthStore((state) => state.login);
  const user = useAuthStore((state) => state.user);
  const favorites = useFavoriteStore((state) => state.favorites)
  const addfav = useFavoriteStore((state) => state.addFavorite)
  const { showLoader, hideLoader } = useLoaderStore()
  const validate = validator()
  const { showToast } = useToastStore()
  // eslint-disable-next-line
  const [tempLoginData, setTempLoginData] = useState<any>(null);
  const [errors, setErrors] = useState<{ email: string; password: string; terms: string; minage: string }>({ email: '', password: '', terms: '', minage: '' });

  useEffect(() => { if (user && user.user_id) { router.replace('/') } })
  useEffect(() => {
    if (terms && minage) {
      setErrors(prev => ({ ...prev, terms: '', minage: '' }))
    }
  }, [terms, minage])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = urlParams.get('access_token');
    showLoader()
    const fetchProfile = async (token: string) => {
      try {
        const url = `https://graph.facebook.com/v19.0/me?fields=id,name,email,picture.type(large)&access_token=${token}`;
        const res = await fetch(url, { cache: 'no-store' })
        const profileData = await res.json();
        if (profileData?.email === undefined) {
          hideLoader();
          showToast('User detail not found.', 'error');
          return
        }
        const userObj = buildUserObj({
          name: profileData.name,
          email: profileData.email,
          picture: profileData.picture?.data?.url,
          login_type: "Facebook"
        });

        await handleLoginApi(userObj, router, setErrors);
      } catch (err) {
        hideLoader()
        console.error('Error fetching profile:', err);
      }
    };

    if (accessToken) {
      fetchProfile(accessToken);
    } else {
      hideLoader()
      console.log('No access token found in URL hash.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const emailError = validate.email(useremail)

  const syncdata = async (user_id: string) => {
    const res = await syncfav(favorites, user_id)
    if (res && res.length) {
      const existingIds = new Set(Object.keys(useFavoriteStore.getState().favorites));
      // eslint-disable-next-line
      res.forEach((d: any) => {
        if (!existingIds.has(String(d.d_id))) {
          addfav(d);
          existingIds.add(String(d.d_id));
        }
      });
    }
  }

  // eslint-disable-next-line
  async function handleLoginApi(userObj: any, router: any, setErrors: (err: any) => void, setLoading?: (loading: boolean) => void) {
    showLoader()
    try {
      const res = await fetchWithLoader('drama_user_registration_json_v2.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObj),
      });

      const data = await res.json();
      // console.log(data.data)
      if ((data.data?.ErrorCode === -1 || data.data?.ErrorCode === 0) && data.data?.Data?.user_email_auth === "1") {
        // console.log('User data:', data.data.Data)
        if (data.data?.Data?.device_list?.length > 0) {
          setIsRevoke(true);
          setDevices(data.data.Data.device_list);
          setTempLoginData(data.data.Data);
          // console.log('device list 0')
          return;
        }
        login(data.data.Data);
        syncdata(data.data.Data.user_id)
        showToast("Login Successful", "success")
        router.replace('/dashboard?firstlogin=1');
        return
      }
      if (data.data.ErrorCode === -7) {
        showToast(data.data.ErrorMessage + "!", "error")
        // router.push('/signup');
      }
      if (data.data.ErrorCode === -4) {
        showToast(data.data.ErrorMessage + "!", "error")
      }
      if (data.data.Data.user_email_auth === "0") {
        localStorage.setItem('_id', data.data.Data.user_id)
        fetch('https://dramasstory.com/web/drama_otp_resend.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_email: userObj.user_email })
        }).then(res => res.json()).then(data => {
          if (data?.data?.Data?.otp !== "") {
            const hash = tohash(data?.data?.Data?.otp.toString());
            const final = `${hash?.slice(0, 5)}${data?.data?.Data?.otp}${hash?.slice(5)}`;
            sessionStorage.setItem('_hash', `${final}`);
            router.replace(`/verifyotp/?emailauth=${userObj.user_email}`);
            return;
          } else {
            router.replace(`/verifyotp/?emailauth=${userObj.user_email}`);
            // router.replace('/signup');
          }
        })
      }
    } catch (err) {
      console.log(err)
      setErrors({ password: 'Invalid credentials' });
    } finally {
      if (setLoading) {
        setLoading(false);
      }
      hideLoader()
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const userObj = buildUserObj({
      email: useremail,
      login_type: "Manualsignin",
      password: password
    });
    // const device = deviceInfo()
    // const deviceId = tohash(`${device.name}${device.platform}${device.os}${useremail}`)

    // const obj = {
    //   user_email: useremail,
    //   user_password: password,
    //   a_id: 0,
    //   login_type: "Manualsignin",
    //   device_id: deviceId,
    //   apple_socail_id: "deded",
    //   device_name: device.name,
    //   fcm_id: "",
    //   user_name: "",
    //   user_image: "",
    //   user_dob: "2024-01-01",
    //   app_ver: device.version,
    //   user_cc: "US",
    //   dev_cc: "US",
    //   dev_make: device.os,
    //   dev_model: device.platform,
    //   app_usage_counter: "5000",
    //   dev_lang: "eng"
    // }
    const newErrors = {
      email: emailError ?? '',
      password: password.trim() === '' ? 'Password required' : '',
      minage: !minage ? 'confirm minimum age' : '',
      terms: !terms ? 'agree to terms' : ''
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(Boolean)) return;
    // console.log(userObj)
    await handleLoginApi(userObj, router, setErrors);

  };



  const logoutDevice = useCallback((deviceId: string) => {
    const device = deviceInfo()
    const device_id = tohash(`${device.name}${device.platform}${device.os}${useremail}${device.version}`)
    fetchWithLoader('user_revoke_json.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: tempLoginData.user_id,
        user_email: tempLoginData.user_email,
        device_id: device_id,
        logout_device_id: deviceId,
        device_name: device.name,
        fcm_id: "0",
      })
    }).then(res => res.json()).then(data => {
      if (data.data.Data?.hasOwnProperty('user_email')) {
        showToast("Device revoked successfully", "success")
        const obj = { ...tempLoginData, device_list: [] };
        login(obj);
        router.replace('/dashboard');
      }
    }).catch(err => {
      console.error(err);
      showToast("Failed to logout device", "error");
    });
  }, [login, router, showToast, tempLoginData, useremail]);

  return (
    <>

      <div className={`${style.loginSec} signUpSec`}>
        <div className="container">
          <div className="signupForm">
            <form onSubmit={handleSubmit}>
              <h2>Welcome to DramaFlicks</h2>
              <div className="field">
                <div className="email">
                  <input type="email"
                    onChange={e => setUseremail(e.target.value)}
                    onBlur={() => setErrors((prev) => ({
                      ...prev,
                      email: validate.email(useremail) ?? ''
                    }))}
                    name="Email" id="email" placeholder='Email*' autoComplete="email" required />
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M18.3104 6.379C18.5757 7.36621 18.5757 8.72811 18.5757 10.8299C18.5757 13.8152 18.5757 15.3079 17.8154 16.3542C17.5699 16.6922 17.2727 16.9894 16.9348 17.2349C15.8884 17.9952 14.3957 17.9952 11.4104 17.9952H9.81808C6.83278 17.9952 5.34008 17.9952 4.29371 17.2349C3.95575 16.9894 3.65855 16.6922 3.41301 16.3542C2.65278 15.3079 2.65277 13.8152 2.65277 10.8299C2.65277 8.72111 2.65277 7.35713 2.92076 6.36914L4.59481 8.04325C5.89436 9.34278 6.91279 10.3612 7.81419 11.049C8.73684 11.7529 9.60687 12.1665 10.6143 12.1665C11.6218 12.1665 12.4918 11.7529 13.4145 11.049C14.3159 10.3612 15.3343 9.34278 16.6339 8.04324L18.1905 6.48663L18.3104 6.379Z" fill="#9B9D9C" />
                      <path d="M17.7793 5.25635L17.6926 5.32806L17.3686 5.61888L15.8215 7.166C14.4826 8.50484 13.5201 9.4656 12.6898 10.099C11.8734 10.722 11.2555 10.9718 10.6141 10.9718C9.97269 10.9718 9.3548 10.722 8.53836 10.099C7.70814 9.4656 6.7456 8.50484 5.40672 7.166L3.56929 5.32856L3.4693 5.22912C3.71483 4.89118 3.9555 4.66984 4.29347 4.42431C5.33984 3.66406 6.83254 3.66406 9.81784 3.66406H11.4101C14.3955 3.66406 15.8881 3.66406 16.9345 4.42431C17.2725 4.66984 17.5338 4.91841 17.7793 5.25635Z" fill="#9B9D9C" />
                    </svg>
                  </span>

                </div>
                <p className={style.error} style={{ opacity: errors.email ? '1' : '0' }}>{errors.email || "Error"}</p>
              </div>

              <div className="field rmrgin">
                <div className="password">
                  <input className="Pswrd" type={showPassword ? "text" : "password"}
                    onChange={e => setPassword(e.target.value)}
                    onBlur={() => setErrors((prev) => ({
                      ...prev,
                      password: password.trim() === '' ? 'Password required' : ''
                    }))}
                    name="password" id="password" placeholder='Password*' required />

                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" className='Lal-Chand'>
                      <path d="M5.32263 8.38487C8.76609 8.50991 12.3768 8.18006 15.8014 8.37221C16.8155 8.42898 17.6076 8.88041 17.9731 9.72881C18.0981 10.0188 18.1556 10.3333 18.1556 10.6489L18.1541 18.2113C18.1541 18.846 17.8983 19.4601 17.4284 19.8874C17.0829 20.2015 16.6395 20.409 16.1462 20.4577L5.00543 20.4558C4.00247 20.3039 3.20009 19.4946 3.07275 18.4863L3.07659 10.6957C3.07697 9.60339 3.83601 8.64069 4.90763 8.42936C5.04225 8.4029 5.1811 8.38794 5.32263 8.38525V8.38487ZM11.6714 12.6311C10.3018 11.2634 8.22721 13.3161 9.52129 14.6831C9.61104 14.7778 9.86878 14.9155 9.88604 15.0068C9.92362 15.5625 9.83541 16.1812 9.88412 16.7293C9.96466 17.6325 11.2591 17.6551 11.342 16.7293C11.3922 16.1697 11.2963 15.5426 11.3466 14.9753C12.18 14.479 12.371 13.3299 11.6711 12.6311H11.6714Z" fill="#9B9D9C" />
                      <path d="M11.6714 12.6286C12.3714 13.3275 12.18 14.4766 11.3469 14.9729C11.2963 15.5401 11.3922 16.1672 11.3423 16.7268C11.2595 17.6527 9.96502 17.6301 9.88448 16.7268C9.83577 16.1791 9.92398 15.5605 9.88639 15.0043C9.86875 14.913 9.61101 14.7753 9.52164 14.6806C8.22756 13.3136 10.3018 11.2609 11.6714 12.6286Z" fill="#1F222B" />
                      <path d="M14.6314 2.65765C13.864 1.6915 12.5388 0.981563 11.3019 0.878773C10.9364 0.848473 10.2882 0.846938 9.9238 0.878773C8.53575 1.00036 7.17072 1.81922 6.39366 2.95413C5.4417 4.3441 5.13215 6.82118 5.20502 8.47272L7.42638 8.47904C7.35389 6.91226 7.71842 4.06679 9.38952 3.38447C10.2567 3.03046 11.537 3.08454 12.3175 3.6307C13.5744 4.51017 13.6568 6.2902 13.5989 7.68439L13.5552 8.54544L15.8653 8.37515L15.896 7.68439C15.9804 5.91816 15.7602 4.0783 14.6314 2.65765Z" fill="#9B9D9C" />
                    </svg>
                  </span>

                  {password !== "" && <>
                    {!showPassword && <span className="showEye"
                      onClick={() => setShowPassword(!showPassword)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.664 0.484375L14.3328 3.81558C9.82084 0.613975 4.56004 2.48597 0.936035 9.48438C1.90564 11.3564 2.99524 12.854 4.15204 13.9964L0.936035 17.2124L2.20804 18.4844L18.936 1.75637L17.664 0.484375ZM9.03843 8.58197C8.53924 8.58197 8.13604 8.17877 8.13604 7.67957C8.13604 7.18037 8.53924 6.77718 9.03843 6.77718C9.53764 6.77718 9.94084 7.18037 9.94084 7.67957C9.94084 8.17877 9.53284 8.58197 9.03843 8.58197ZM11.76 6.38838C11.2272 6.07158 10.6032 5.88438 9.93604 5.88438C7.94884 5.88438 6.33604 7.49718 6.33604 9.48438C6.33604 10.1516 6.51844 10.7756 6.84004 11.3084L5.35683 12.7916C4.42564 11.9324 3.53764 10.8284 2.73604 9.48438C4.79044 6.03797 7.38244 4.08438 9.93604 4.08438C10.992 4.08438 12.0528 4.42998 13.08 5.06838L11.76 6.38838Z" fill="#9B9D9C" />
                        <path d="M16.9918 6.40234L15.811 7.58314C16.2718 8.15914 16.7182 8.78314 17.1358 9.48394C15.0814 12.9303 12.4894 14.8839 9.93581 14.8839C9.51821 14.8839 9.10061 14.8119 8.68301 14.7111L7.26221 16.1319C11.3422 17.8167 15.7678 15.6039 18.9358 9.48394C18.331 8.31274 17.6782 7.29034 16.9918 6.40234Z" fill="#9B9D9C" />
                      </svg>
                    </span>}

                    {showPassword && <span className="showEye"
                      onClick={() => setShowPassword(!showPassword)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M5.53924 3.34415C7.67955 1.85471 10.0464 1.35887 12.6096 2.36975C16.5452 3.92159 18.936 9.01295 18.936 9.01295C18.6116 9.71471 17.1298 12.251 15.72 13.525C14.4111 14.7077 12.6096 15.661 12.6096 15.661C10.8284 16.369 8.68756 16.571 6.14452 15.0989C2.73556 12.9936 0.936035 9.01295 0.936035 9.01295C1.2778 8.25215 3.049 5.01119 5.53924 3.34415ZM6.925 13.5624C8.94436 14.6674 10.6445 14.5157 12.0591 13.9843C12.0591 13.9843 13.4895 13.2691 14.5292 12.3816C15.6485 11.4254 16.8255 9.52223 17.0832 8.99567C17.0832 8.99567 15.1848 5.17487 12.0596 4.01039C10.0239 3.25199 8.14467 3.62399 6.44499 4.74191C4.46739 5.99279 3.061 8.42495 2.78979 8.99567C2.78979 8.99567 4.21875 11.9827 6.92595 13.5624H6.925Z" fill="white" />
                        <path d="M9.93577 5.44336C11.9124 5.44336 13.5146 7.0456 13.5146 9.02224C13.5146 10.9989 11.9124 12.6011 9.93577 12.6011C7.95913 12.6011 6.35689 10.9989 6.35689 9.02224C6.35689 7.0456 7.95913 5.44336 9.93577 5.44336ZM10.843 8.10976C11.3407 8.10976 11.7444 7.70608 11.7444 7.20832C11.7444 6.71056 11.3407 6.30688 10.843 6.30688C10.3452 6.30688 9.94153 6.71056 9.94153 7.20832C9.94153 7.70608 10.3452 8.10976 10.843 8.10976Z" fill="white" />
                      </svg>
                    </span>}
                  </>}
                </div>
                <p className={style.error} style={{ opacity: errors.password ? '1' : '0' }}>{errors.password || "Error"}</p>
              </div>

              <div className="forget">
                <Link href='forget'>Forgot Password?</Link>
              </div>
              <div className="loginBtn">
                <button type='submit' className="commonBtn">Sign In</button>
                <p className={` ${style.SetSpace} ${style.error}`}
                  style={{ opacity: errors.terms || errors.minage ? '1' : '0' }}
                >
                  
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Please check the box to continue</p>

              </div>
              <div className={style.LogSignUp}>
                <p>Don&#39;t have an account? <Link href="signup">Sign Up</Link></p>
                <p className={style.continue}>or continue with</p>
              </div>
              <div className={style.socialLogin}>
                <FacebookLogin handleLoginApi={handleLoginApi} terms={terms} minage={minage} seterr={setErrors} />

                <GoogleLogin handleLoginApi={handleLoginApi} terms={terms} minage={minage} seterr={setErrors} />
              </div>
              <div className="checkTpolicy">
                <label>
                  <div className="checkboxed">
                    <input type="checkbox" name="checkbox" onChange={e => setTerms(e.target.checked)} />
                  </div>
                  <p className="condition">I have read and agree to DramaFlicks <Link target='_blank' href="/terms-of-use">Terms of Use</Link> and <Link target='_blank' href="/privacy-policy">Privacy Policy.</Link> </p>
                </label>

                <label>
                  <div className="checkboxed">
                    <input type="checkbox" name="checkbox" onChange={e => setMinage(e.target.checked)} />
                  </div>
                  <p className="condition">I am over the minimum age requirement of my country as per <Link target='_blank' href="https://www.globalratings.com/ratingsguide.aspx">IARC.</Link></p>
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>


      {/* Revoke  */}
      {isRevoke && <Revoke logoutDevice={logoutDevice} close={() => setIsRevoke(false)} devices={devices} />}
    </>
  );
}


// try {
//   const res = await fetch('https://dramasstory.com/web/drama_user_registration_json_v2.php', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(obj),
//   });

//   if (!res.ok) throw new Error('Login failed');
//   const data = await res.json();
//   if (data.data.ErrorCode === -1 && data.data.Data.user_email_auth === "1") {
//     login(data.data.Data);
//     router.replace('/dashboard');
//   }
//   if (data.data.ErrorCode === -7) {
//     router.replace('/signup');
//   }
//   if (data.data.Data.user_email_auth === "0") {
//     login(data.data.Data);
//     fetch('https://dramasstory.com/web/drama_otp_resend.php', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ user_email: useremail })
//     }).then(res => res.json()).then(data => {
//       console.log(data)
//       if (data?.data?.Data?.otp !== "") {
//         const hash = tohash(data?.data?.Data?.otp.toString());
//         const final = `${hash?.slice(0, 5)}${data?.data?.Data?.otp}${hash?.slice(5)}`;
//         localStorage.setItem('_hash', `${final}`);
//         router.replace(`/verifyotp/?emailauth=${useremail}`);
//         return;
//       } else {
//         router.replace('/signup');
//       }
//     })
//   }
// } catch (err) {
//   console.log(err)
//   setErrors({ password: 'Invalid credentials' });
// } finally {
//   // setLoading(false);
// }

//apple
{/* <div className={style.LoginsocialIcon}>
  <a href="">
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
      <path d="M4.63554 14.9632C4.84925 10.7235 8.14358 6.99495 12.5365 8.57364C13.5204 8.92713 14.1811 9.45175 15.2774 9.13582C16.1963 8.87094 17.0133 8.38677 17.9878 8.20698C20.1249 7.81271 22.4798 8.70656 23.6941 10.5546C21.7023 11.8659 20.6934 14.1056 21.2177 16.5085C21.5852 18.1925 22.809 19.539 24.328 20.2402C23.833 21.8735 22.9864 23.3812 21.9627 24.7258C20.8193 26.2275 19.6422 27.2202 17.6629 26.5392C16.4284 26.1145 15.8545 25.6438 14.4223 25.8053C13.2552 25.9369 12.2757 26.7059 11.1257 26.7951H10.7476C10.6194 26.7476 10.4751 26.7499 10.3378 26.7152C9.06913 26.3944 7.87242 24.723 7.16185 23.6628C5.81299 21.6504 4.99603 19.2876 4.70246 16.8674L4.63554 16.1177C4.64974 15.7347 4.61628 15.3459 4.63554 14.9635V14.9632Z" fill="white" />
      <path d="M19.285 2.17188C19.5322 4.34935 18.1701 6.62442 16.2202 7.49837C15.6832 7.73885 15.0244 7.93052 14.442 7.80595C14.2737 6.79844 14.6248 5.71452 15.1336 4.85374C15.9992 3.39032 17.5864 2.28489 19.285 2.17188Z" fill="white" />
    </svg>
  </a>
</div> */}